import type { ICategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

export interface ICategoryItem {
    text: string;
    count: number;
    name: string;
    id: string;
    isCustomCategory: boolean;
    isChild: boolean;
    icon: string;
    forApi: string;
    parentId: string;
}

const convertCategory = ({ Count = 0, text: Name, sons: Sons = [], id }, parentId = null) => {
    let text;
    if (parentId) {
        text = `${translate(`${parentId}/${Name}`, true)}`;
    } else {
        text = translate(Name);
    }
    const forApi = `${parentId ? `${parentId}~` : ``}${id}`;
    return {
        text,
        count: Count,
        name: text,
        id: forApi,
        isCustomCategory: false,
        isChild: parentId !== null,
        icon: text.replace(/~.+/g, "").replace(/\s+/g, "-").toLowerCase(),
        forApi,
        parentId,
    };
};

export const onCategorySelected = (categories) => {
    const value = categories.length > 0 ? categories.map((cat) => cat.id).join(",") : null;
    allTrackers.dispatchTrackEvent("Drop Down", "click", `Table/Category/${value}`);
    proNavigator.updateParams({
        selectedCategory: value,
    });
};

export const getCategoriesOptions = (categories: ICategory[]): ICategoryItem[] => {
    return categories.reduce((result, category) => {
        return [
            ...result,
            {
                ...convertCategory(category),
                sons: (category.Sons || []).map((son) => convertCategory(son, category.id)),
            },
        ];
    }, []);
};
